// extracted by mini-css-extract-plugin
export default {"infoBanner":"d5jS5dToBfFYJcxTd779","iconInfo":"R57CBNYDsw6efASPVwzA","bannerText":"_6srfjFmoeVVSTzb03O6Y"};